import React, { ReactElement } from "react";
import { AgencyMember, AgencyMemberId } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { ASSIST_SVG } from "../../../utils/svgs";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppListItem } from "../../Generic/AppList";

interface Props {
  member: AgencyMember;
  onClick: () => void;
}

export function AgencyListItemAgencyMemberRow(props: Props): ReactElement {
  const memberAvatar =
    props.member.photoUrl === null ? (
      <div className="AgencyListItemAgencyMemberIcon Default">{ASSIST_SVG}</div>
    ) : (
      <img className="AgencyListItemAgencyMemberIcon" src={props.member.photoUrl} />
    );

  const chatWithMember = [
    translate(STRINGS.CONTACT),
    props.member.firstName,
    props.member.lastName,
  ].join(" ");

  return (
    <AppCard key={AgencyMemberId.unwrap(props.member.id)} onClick={() => props.onClick()}>
      <AppCardContent>
        <AppListItem leading={memberAvatar} title={chatWithMember} />
      </AppCardContent>
    </AppCard>
  );
}
